
<template>
  <div class="wrapper">
    <div class="container home-body" :style="fields.image">

    <Header />
    <!-- saving prismic image tag for easy reference -->
    <!-- <prismic-image :field="fields.image"/> -->
      <div class="contact_info p-5 m-5">
       <div class="row">
         <div class="col-md-5 my-auto mx-auto">
          <p class="lead">Address: <i class="fas fa-map-marker ml-2"> </i></p>
          <prismic-link :field="fields.google_maps_link" v-if="fields.google_maps_link">
            <prismic-rich-text :field="fields.address"/>
          </prismic-link>
          <prismic-rich-text :field="fields.address" v-else/>
         </div>
         <div class="col-md-5 text-md-right my-auto mx-auto">
          <p class="lead"><i class="fas fa-mobile-alt mr-2"> </i> Phone: </p>
          <a :href="'tel:' + fields.phone[0].text" v-if="fields.phone">
            <prismic-rich-text :field="fields.phone"/>
          </a>
         </div>
       </div>
      </div>
    </div>

    <Footer />

  </div>
</template>

<script>
import Header from '../components/Header'
import Footer from '../components/Footer'

export default {
  name: 'Home',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      fields: {
        image: null,
        address: null,
        phone: null,
        google_maps_link: null
      }
    }
  },
  methods: {
    fetchPrismicContent () {
      this.$prismic.client.getSingle('page-home')
        .then((document) => {
          // Pulling out image and setting it as background-image on wrapper div
          this.fields.image = `background-image: url('${document.data.page_image.url}');`

          this.fields.google_maps_link = document.data.google_maps_link
          this.fields.address = document.data.page_address
          this.fields.phone = document.data.page_phone
        })
    }
  },
  mounted () {
    this.fetchPrismicContent()
  }
}
</script>

<style scoped>
  .wrapper {
    padding-top: 150px;
  }

  .home-body {
    background-size: cover;
    background-repeat: no-repeat;
    padding: 0 0 10px 0;
    border-top: 10px solid #000F63;
    border-bottom: 10px solid #000F63;
  }

  .contact_info {
    background-color: #000F63;
    border-radius: 100px;
    border: 15px solid #fff;
    color: #fff;
    opacity: 0.9;
  }

  a {
    text-decoration: none;
    color: #fff;
  }

  a:hover {
    color: #d2d2d2;
  }
</style>
